import React, { useContext, useEffect } from "react";
import { ActiveContext } from "../../App";
import { useLocation } from "react-router-dom";
import { RPAHeader } from "./RPAHeader";
import { Header } from "../header/Header";
import { Footer } from "../Footer";
import AgenticAI from "./AjenticAi";
import RPAIndustryGrid from "./RPAIndustryGrid";
import FeaturedRPA from "./FeaturedRPA";
import SAPAutomation from "./SAPAutomation";
import RPACta from "./RPACta";

export default function RPA() {
  const [active, setActive] = useContext(ActiveContext);
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/RPA-theja.in") {
      setActive("rpa");
    }
  });

  useEffect(() => {
    if (localStorage.getItem("idScroll") !== null) {
      document
        .getElementById(
          localStorage.getItem("idScroll")
            ? localStorage.getItem("idScroll")
            : "",
        )
        .scrollIntoView({ behavior: "instant" });
    }
    localStorage.removeItem("idScroll");
  }, []);
  return (
    <div className="fixed inset-0 w-screen h-screen flex flex-col overflow-hidden">
      <div>
        <Header />
      </div>
      <div className=" w-full h-full tracking-wider overflow-y-auto overflow-x-hidden ">
        <div id="exploreSolution">
          <RPAHeader />
        </div>
        <div id="AgenticAI">
          <AgenticAI />
        </div>
        <SAPAutomation />
        {/* <FeaturedRPA /> */}
        <RPAIndustryGrid />
        <RPACta />
        <div id="footer">
          {" "}
          <Footer />
        </div>{" "}
      </div>
    </div>
  );
}
